/**
 * Database type.
 */
export type DatabaseType =
    "mysql"|
    "postgres"|
    "mariadb"|
    "sqlite"|
    "cordova"|
    "react-native"|
    "sqljs"|
    "oracle"|
    "mssql"|
    "mongodb";
